import React, { Component } from "react";
import Translations from "../../services/translation.service";
import Flow from "../../services/flow.service";
import Errors from "../../services/errors.service";
import User from "../../services/user.service";
import GetApp from "./get-app.component";
import Spinner from "./spinner.component";

export default class Message extends Component {
  subscriptions = [];
  state = {
    loading: false,
  };

  componentWillUnmount() {
    if (this.subscriptions) {
      for (let subscription of this.subscriptions) {
        subscription.unsubscribe();
      }
    }
  }

  componentDidMount() {
    this.subscriptions.push(
      Translations.getKeysObsrv().subscribe((data) => {
        this.forceUpdate();
      })
    );
  }

  startLoading = () => {
    this.setState({
      loading: true,
    });
  };

  stopLoading = () => {
    this.setState({
      loading: false,
    });
  };

  render() {
    let message = null;
    let type = "success";
    let icon = "success_icn";

    let message_prefix = "scr_3.7_C_";

    let cancel_button = "";
    let action_button = "";

    let size = this.props.size || false;
    let message_key = this.props.message ? this.props.message : "error_general";

    if (message_key.indexOf("error") !== -1 || this.props.error) {
      type = "failure";
      icon = "failure_icn";
    }

    if (this.props.error) {
      message_key = "error_" + this.props.error;
      message_key = message_key.replace("error_-", "error_");

      if (Translations.keys[message_key]) {
        message = {
          title: Translations.keys[message_key],
          text: "",
          button_text: "",
          code: this.props.error,
          key: message_key,
        };
      } else if (this.props.error === "invalid_timestamp") {
        message = {
          title: Translations.keys["ob_invalid_timestamp"],
        };
      } else {
        if (!isNaN(this.props.error)) {
          // untranslated error
          let coded = "" + this.props.error;
          coded = coded.replace('-', '');
          message = {
            title: Translations.keys[message_prefix + "general_error_title"],
            text: "Error code: " + coded,
            code: this.props.error,
            key: message_key,
            button_text:
              Translations.keys[message_prefix + "general_error_button"] ||
              Translations.keys[message_prefix + "general_error_action_btn"],
          };
        } else {
          // non numerical error
          message_key = message_prefix + message_key;
          if (!Translations.keys[message_key + "_title"]) {
            message_key = message_prefix + "general_error";
          }
          message = {
            title: Translations.keys[message_key + "_title"],
            text:
              Translations.keys[message_key + "_description1"],
            button_text:
              Translations.keys[message_key + "_button"] ||
              Translations.keys[message_key + "_action_btn"],
          };
        }
      }
    } else {
      if (this.props.prefix) {
        message_key = this.props.prefix;
      } else {
        message_key = message_prefix + message_key;
      }

      if (!Translations.keys[message_key + "_title"]) {
        message_key = message_prefix + "general_error";
      }

      message = {
        title: Translations.keys[message_key + "_title"],
        text:
          Translations.keys[message_key + "_description1"] +
          "<br>" +
          Translations.keys[message_key + "_description2"],
        button_text:
          Translations.keys[message_key + "_button"] ||
          Translations.keys[message_key + "_action_btn"],
      };
    }

    if (size === "small") {
      icon = "";
    }

    if (this.props.icon) {
      icon = this.props.icon;
    }

    let action = this.props.action;
    let cancel = this.props.cancel;

    if (action) {
      action_button = (
        <div className="center action-btn margb">
          {this.props.active_search_vanity ? (
            <button
              onClick={() => {
                this.startLoading();
                action(this.props.active_search_vanity, "msg");
              }}
              className="common-button"
            >
              {message.button_text ? message.button_text : "OK"}
            </button>
          ) : (
            <button
              onClick={() => {
                this.startLoading();
                action();
              }}
                className="common-button"
            >
              {message.button_text ? message.button_text : "OK"}
            </button>
          )}
        </div>
      );
    } else {
      if (action !== false) {
        if (type === "success") {
          action_button = (
            <div className="center action-btn margb">
              <button
                onClick={() => {
                  this.startLoading();
                  Flow.next(9);
                }}
                className="common-button"
              >
                {message.button_text ? message.button_text : "Next"}
              </button>
            </div>
          );
        }
        if (type === "failure") {
          action_button = (
            <div className="center action-btn margb">
              <button
                onClick={() => {
                  this.startLoading();
                  if (this.props.error) {
                    Errors.doAction(message.code);
                  } else {
                    User.fetchFlowStatus(733333)
                      .then(() => this.stopLoading)
                      .catch(() => this.stopLoading);
                  }

                  //Flow.goTo();
                }}
                className="common-button"
              >
                {message.button_text ? message.button_text : "OK"}
              </button>
            </div>
          );
        }
      }
    }

    if (cancel) {
      cancel_button = (
        <div className="center margb-30">
          <div className="cancel-lnk" onClick={cancel}>
            Cancel
          </div>
        </div>
      );
    }

    let content = (
      <div className={size !== "small" ? "container page" : ""}>
        <div className={size !== "small" ? "narrow-column" : "small_error"}>
          <div
            className={
              (size !== "small" ? "center" : "") +
              " message " +
              size +
              " " +
              type
            }
          >
            <div className={icon ? "status_icn " + icon : ""} />
            <div className="message-title">{message.title}</div>
            <div
              className="message-desc"
              dangerouslySetInnerHTML={{ __html: message.text }}
            />
            <div className="message-desc">{Translations.keys["kw_error_code_number"]}: {message.code ? message.code : Translations.keys["kw_error_code_unknown"]}</div>

            {action_button}
            {cancel_button}
          </div>
          {size && size !== "small" ? <GetApp /> : ""}
        </div>
      </div>
    );
    if (this.state.loading) {
      content = <Spinner />;
    }
    return content;
  }
}
